/* eslint-disable eqeqeq */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import type { Enterprise } from 'app/scripts/models/enterprise';
import type { Organization } from 'app/scripts/models/organization';
import BluebirdPromise from 'bluebird';
import { TrelloWindow } from '@trello/window-types';
declare const window: TrelloWindow;

const { QuickLoad } = require('@trello/quickload');
import { idCache } from '@trello/shortlinks';
import { ModelCache } from 'app/scripts/db/model-cache';
import Payloads, {
  PayloadQuery,
  orgBoardsMapping,
  attachmentsUnion,
} from 'app/scripts/network/payloads';
const Promise = require('bluebird');
import { rpc } from 'app/scripts/network/rpc';
import { Util } from 'app/scripts/lib/util';
import _ from 'underscore';
import moment from 'moment';
import { ApiError } from 'app/scripts/network/api-error';
import { loadApiDataFromPayload } from './loadApiDataFromPayload';
import { loadApiDataFromQuickLoad } from './loadApiDataFromQuickLoad';
import { triggerWaits, waitFor } from './waitFor';
import type { Board } from '../models/board';

const extendQuery = (
  { query, mappingRules }: PayloadQuery,
  moreQuery: object,
) => ({
  query: { ...query, ...moreQuery },
  mappingRules,
});

export const EnterpriseMemberDashboardEndpoints = {
  deactivatedEnterprise: 'deactivated',
  licensed: 'licensed',
  licensedCollaborator: 'boardGuests',
  managedFree: 'activeManagedFree',
};

class LoaderHelpers {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: (...args: unknown[]) => any;

  triggerWaits(eventName: string) {
    return triggerWaits(eventName);
  }

  waitFor(type: string, callback: () => void) {
    return waitFor(type, callback);
  }

  await(type: string) {
    return new BluebirdPromise((resolve) => {
      return this.waitFor(type, resolve);
    });
  }

  getUpToDateBoard(idBoardOrShortLink: string): Board | null {
    const idBoard = idCache.getBoardId(idBoardOrShortLink);
    if (idBoard == null) {
      return null;
    }

    const board = ModelCache.get('Board', idBoard);
    if (board == null) {
      return null;
    }

    const lastUpdateChannel = rpc.getIxLastUpdate(board.id);
    if (lastUpdateChannel != null) {
      return board;
    } else {
      return null;
    }
  }

  getPreloadTraceId() {
    return QuickLoad.getPreloadTraceId();
  }
}

class Loaders extends LoaderHelpers {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  for(owner: 'header' | 'top-level', loadName: string, ...args: any) {
    return this[loadName](...Array.from(args || []));
  }

  loadHeaderData() {
    return loadApiDataFromQuickLoad('MemberHeader', {
      idModel: 'me',
      isHeaderLoad: true,
      modelType: 'Member',
    });
  }

  loadBoardsData() {
    return loadApiDataFromPayload('Member', {
      id: 'me',
      payload: Payloads.boardsMinimal,
    }).then((delta) => ['Member', delta, Payloads.boardsMinimal.mappingRules]);
  }

  loadBoardMinimal(id: string) {
    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.boardMinimal,
    });
  }

  loadBoardData(id: string, payload: PayloadQuery, traceId: string) {
    return loadApiDataFromPayload('Board', {
      id,
      payload,
      traceId,
    });
  }

  loadBoardMembers(id: string) {
    return loadApiDataFromPayload('Member', {
      id,
      path: `boards/${id}/members`,
    });
  }

  loadBoardAttachment(idBoard: string) {
    return loadApiDataFromPayload('Board', {
      id: idBoard,
      payload: Payloads.boardAttachment,
    });
  }

  loadCardData(idOrShortId: string, idBoard: string, traceId: string) {
    if (typeof idBoard !== 'undefined' && idBoard !== null) {
      return loadApiDataFromPayload('Card', {
        id: idOrShortId,
        payload: Payloads.card,
        path: `boards/${idBoard}/cards/${idOrShortId}`,
        traceId,
      });
    } else {
      return loadApiDataFromQuickLoad('PreloadCard', {
        idModel: idOrShortId,
        traceId,
        modelType: 'Card',
      });
    }
  }

  loadCardLinkData(idOrShortId: string) {
    const query = { fields: ['name', 'shortLink', 'idBoard'].join(',') };
    return loadApiDataFromPayload('Card', {
      id: idOrShortId,
      payload: { query },
    });
  }

  loadCardCompleterData(id: string) {
    return loadApiDataFromPayload('Card', {
      id,
      payload: Payloads.cardCompleter,
    });
  }

  loadCardId(idBoard: string, idShort: string) {
    return loadApiDataFromPayload('Card', {
      id: idShort,
      payload: Payloads.idCard,
      path: `boards/${idBoard}/cards/${idShort}`,
    }).then((card) => card.get('id'));
  }

  loadCardDetails(idCard: string, limit: number) {
    return loadApiDataFromPayload('Card', {
      id: idCard,
      payload: extendQuery(Payloads.cardDetails, { actions_limit: limit }),
      path: `cards/${idCard}`,
    });
  }

  loadCardHideDetails(idCard: string, limit: number) {
    return loadApiDataFromPayload('Card', {
      id: idCard,
      payload: extendQuery(Payloads.cardDetails, {
        actions: 'commentCard,copyCommentCard,createCard,copyCard',
        actions_limit: limit,
      }),
      path: `cards/${idCard}`,
    });
  }

  loadCardVoters(id: string) {
    return loadApiDataFromPayload('Card', {
      id,
      payload: Payloads.cardVoters,
      path: `cards/${id}`,
    });
  }

  loadCardCopyData(idBoard: string, idOrShortId: string) {
    return loadApiDataFromPayload('Card', {
      id: idOrShortId,
      payload: Payloads.cardCopy,
      path: `boards/${idBoard}/cards/${idOrShortId}`,
    });
  }

  loadCardAttachment(idCard: string) {
    return loadApiDataFromPayload('Card', {
      id: idCard,
      payload: Payloads.cardAttachment,
    });
  }

  loadNotification(id: string) {
    return loadApiDataFromPayload('Notification', {
      id,
      payload: {
        query: {
          fields: 'all',
        },
      },
    });
  }

  loadNotificationGroups(idCards: string[]) {
    return loadApiDataFromPayload('NotificationGroup', {
      payload: {
        query: { idCards },
      },
      path: 'notificationGroups',
    });
  }

  loadMoreUnreadNotifications(limit: number) {
    const unreads = ModelCache.all('Notification').filter((notification) =>
      notification.get('unread'),
    );
    const query = {
      display: true,
      limit,
      read_filter: 'unread',
      page: Math.floor(unreads.length / limit),
    };
    const path = 'members/me/notifications';

    return loadApiDataFromPayload('Notification', {
      payload: { query },
      path,
    });
  }

  loadMoreNotificationGroupData(limit: number, skip: number) {
    if (skip == null) {
      skip = ModelCache.all('NotificationGroup').length;
    }
    const query = {
      limit,
      skip,
      card_fields: [
        'cardRole',
        'due',
        'dueComplete',
        'idBoard',
        'idList',
        'isTemplate',
        'name',
        'subscribed',
      ],
    };
    const path = 'members/me/notificationGroups';

    return loadApiDataFromPayload('NotificationGroup', {
      payload: { query },
      path,
    });
  }

  loadMemberNotificationsCount() {
    const query = { filter: 'all', grouped: true };
    const path = 'members/me/notificationsCount';

    return loadApiDataFromPayload('notificationsCount', {
      payload: { query },
      path,
    });
  }

  loadMinimumMemberDataForTemplatePage(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          organizations: 'all',
          organization_fields: 'products,premiumFeatures',
          organization_paidAccount: 'true',
          organization_paidAccount_fields: Payloads.paidAccountFieldsMinimal,
          fields: 'oneTimeMessagesDismissed',
        },
      },
    });
  }

  loadMemberBoardsData(idOrUsername: string) {
    return loadApiDataFromQuickLoad('MemberBoards', {
      idModel: idOrUsername,
      modelType: 'Member',
    });
  }

  loadMemberCardsData(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: Payloads.memberCards,
    });
  }

  loadMemberCards(
    idOrUsername: string,
    {
      modifiedSince,
      limit,
      before,
    }: {
      modifiedSince?: string;
      limit?: number;
      before?: number;
    } = {},
  ) {
    const query: {
      filter: string;
      stickers: boolean;
      attachments: boolean;
      members: boolean;
      sort: string;
      modifiedSince?: string;
      limit?: number;
      before?: number;
    } = {
      filter: 'visible',
      stickers: true,
      attachments: true,
      members: true,
      sort: '-id',
    };

    if (modifiedSince) {
      query.modifiedSince = modifiedSince;
    }

    if (limit) {
      query.limit = limit;
    }

    if (before) {
      query.before = before;
    }

    return loadApiDataFromPayload('Card', {
      payload: { query },
      path: `members/${idOrUsername}/cards`,
    });
  }

  loadMemberEmail(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          fields: 'email',
          invitationTokens: Util.invitationTokens().join(','),
        },
      },
    });
  }

  loadOrganizationMemberGhost(idOrg: string, username: string) {
    // If we have an invite to this organization (i.e. an invitation token
    // in our cookies) then we need to load the ghost data so we can
    // display the invitation banner
    const idGhost = Util.inviteTokenFor(idOrg)?.split('-')[0];
    if (idGhost == null) {
      return Promise.resolve({});
    }

    const query = {
      fields: Payloads.memberFields,
      invitationTokens: Util.invitationTokens().join(','),
    };

    // Maybe the invitation has already been used or something; we
    // never want to prevent loading of the organization page
    return loadApiDataFromPayload('Member', {
      id: idGhost,
      payload: {
        query,
      },
    }).catch(ApiError, () => ({}));
  }

  loadOrganizationCredits(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationCredits,
    });
  }

  loadMoreActionData(
    modelType: string,
    idOrName: string,
    page: number,
    limit: number,
    idModels: string[],
    filter: string,
  ) {
    const query: {
      filter: string;
      limit: number;
      page: number;
      display: boolean;
      idModels?: string;
    } = { filter: 'all', limit, page, display: true };
    if (typeof idModels !== 'undefined' && idModels !== null) {
      query.idModels = idModels.join(',');
    }
    if (typeof filter !== 'undefined' && filter !== null) {
      query.filter = filter;
    }

    return loadApiDataFromPayload('Action', {
      id: idOrName,
      payload: { query },
      path: `${modelType}s/${idOrName}/actions`,
    });
  }

  loadClosedCards(
    idBoard: string,
    { limit, before }: { limit: number; before: number },
  ) {
    const query: {
      stickers: boolean;
      attachments: boolean;
      pluginData: boolean;
      customFieldItems: boolean;
      limit?: number;
      before?: number;
    } = {
      stickers: true,
      attachments: true,
      pluginData: true,
      customFieldItems: true,
    };
    if (limit != null) {
      query.limit = limit;
    }
    if (before != null) {
      query.before = before;
    }

    return loadApiDataFromPayload('Card', {
      id: idBoard,
      payload: { query },
      path: `boards/${idBoard}/cards/closed`,
    });
  }

  loadListCards(idList: string) {
    return loadApiDataFromPayload('List', {
      id: idList,
      payload: Payloads.listCards,
    });
  }

  loadArchivedLists(idBoard: string) {
    return loadApiDataFromPayload('Board', {
      id: idBoard,
      payload: Payloads.archivedLists,
    });
  }

  loadArchivedListsAndCards(idBoard: string) {
    return loadApiDataFromPayload('Board', {
      id: idBoard,
      payload: Payloads.archivedListsAndCards,
    });
  }

  loadMemberAccountData(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: Payloads.memberAccount,
    });
  }

  loadMemberBillingData(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: Payloads.memberBilling,
    });
  }

  loadMemberLogins(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          fields: 'email',
          logins: true,
        },
      },
    });
  }

  loadMemberProfileData(idOrUsername: string) {
    const payload = Payloads.memberProfile;
    const daysBack = Payloads.memberProfile_daysBack;
    // This is bad and I'm not sure if it's intentional or not. We are mutating the payload object (and probably shouldn't)
    // @ts-expect-error
    payload.action_since = moment().subtract(daysBack, 'days').toString();
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: Payloads.memberProfile,
    });
  }

  loadMemberProfileMinimal(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: Payloads.memberMinimal,
    });
  }

  loadMemberCustomBackgrounds(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          fields: '',
          boardBackgrounds: 'custom',
        },
      },
    });
  }

  loadMemberCustomStickers(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          fields: '',
          customStickers: 'all',
        },
      },
    });
  }

  loadMemberCustomEmoji(idOrUsername: string) {
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: {
        query: {
          fields: '',
          customEmoji: 'all',
        },
      },
    });
  }

  loadMemberEnterpriseUserType(
    enterpriseIdOrName: string,
    idOrUsername: string,
  ) {
    const query = { fields: 'userType' };
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/members/${idOrUsername}`,
    });
  }

  loadMemberEnterpriseActive(enterpriseIdOrName: string, idOrUsername: string) {
    const query = { fields: 'active' };
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/members/${idOrUsername}`,
    });
  }

  loadMemberNonPublicFields(idOrUsername: string) {
    const query = { fields: 'nonPublic' };
    return loadApiDataFromPayload('Member', {
      id: idOrUsername,
      payload: { query },
      path: `members/${idOrUsername}`,
    });
  }

  loadOrganizationPlugins(idOrOrgName: string) {
    const query = { enabledBoards: true };
    return loadApiDataFromPayload('Plugin', {
      payload: { query },
      path: `organizations/${idOrOrgName}/plugins`,
    });
  }

  loadOrganizationData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organization,
    });
  }

  loadOrganizationAccountData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationAccount,
    });
  }

  loadOrganizationBoardsData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationBoardsPage,
    });
  }

  loadWorkspaceBoardsData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.workspaceBoardsPage,
    });
  }

  loadWorkspaceBoardsDataMinimal(idOrOrgName: string) {
    return loadApiDataFromQuickLoad('WorkspaceBoardsPageMinimal', {
      idModel: idOrOrgName,
      modelType: 'Organization',
      mappingRules: {
        boards: orgBoardsMapping,
      },
    });
  }

  loadOrganizationMinimal(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMinimal,
    });
  }

  loadOrganizationMembersData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMembers,
    });
  }

  loadOrganizationMembersDataWithAvailableLicenseCount(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMembersWithAvailableLicenseCount,
    });
  }

  loadOrganizationMembersBoards(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMembersBoards,
    });
  }

  loadOrganizationMembersCollaborators(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMembersCollaborators,
    });
  }

  loadOrganizationMembersMinimal(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMembersMinimal,
    });
  }

  loadOrganizationMembersMinimalWithAvailableLicenseCount(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationFieldsMinimalWithAvailableLicenseCount,
    });
  }

  loadOrganizationMinimalWithoutBoards(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationMinimalWithoutBoards,
    });
  }

  loadOrganizationMaximumAndAvailableLicenseCount(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationFieldsMaximumAndAvailableLicenseCount,
    });
  }

  loadOrganizationExportData(idOrOrgName: string) {
    return loadApiDataFromPayload('Organization', {
      id: idOrOrgName,
      payload: Payloads.organizationExports,
    });
  }

  loadMemberOrganizationsDeactivatedMembers() {
    return loadApiDataFromPayload('Organization', {
      payload: Payloads.memberOrganizationDeactivatedMembers,
      path: 'members/me/organizations',
    });
  }

  loadOrgMemberCardData(idOrOrgName: string, idOrUsername: string) {
    const path = `organization/${idOrOrgName}/members/${idOrUsername}/cards`;
    return loadApiDataFromPayload('Card', {
      id: idOrOrgName,
      payload: Payloads.orgMemberCards,
      path,
    });
  }

  loadOrgNameById(idOrganization: string) {
    const query = { fields: 'name' };
    return loadApiDataFromPayload('Organization', {
      id: idOrganization,
      payload: {
        query,
      },
    }).call('get', 'name');
  }

  loadCurrentBoardMinimal(id: string, traceId?: string) {
    const board = this.getUpToDateBoard(id);
    if (board) {
      return Promise.resolve(board);
    }

    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.currentBoardMinimal,
      traceId,
    });
  }

  loadCurrentBoardFull(id: string, traceId?: string) {
    const board = this.getUpToDateBoard(id);
    if (board) {
      return Promise.resolve(board);
    }

    return loadApiDataFromQuickLoad('CurrentBoardFull', {
      idModel: id,
      modelType: 'Board',
      traceId,
      mappingRules: {
        attachments: attachmentsUnion,
      },
    });
  }

  loadBoardMinimalForDisplayCard(id: string, traceId?: string) {
    const board = this.getUpToDateBoard(id);
    if (board) {
      return Promise.resolve(board);
    }

    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.boardMinimalForDisplayCard,
      traceId,
    });
  }

  loadBoardActions(id: string, traceId: string): BluebirdPromise<unknown> {
    const board = this.getUpToDateBoard(id);
    if (board?.getActions()?.length) {
      return Promise.resolve(board.getActions());
    }

    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.currentBoardActions,
      traceId,
    });
  }

  loadBoardChecklists(id: string, traceId: string) {
    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.boardChecklists,
      traceId,
    });
  }

  loadBoardCompleterData(id: string) {
    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.boardCompleter,
    });
  }

  loadBoardName(idBoard: string) {
    const query = { fields: ['name', 'closed', 'shortLink'].join(',') };
    return loadApiDataFromPayload('Board', {
      id: idBoard,
      payload: { query },
    }).call('get', 'name');
  }

  loadBoardPrefs(idBoard: string) {
    const query = { fields: ['prefs'].join(',') };
    return loadApiDataFromPayload('Board', {
      id: idBoard,
      payload: { query },
    }).call('get', 'prefs');
  }

  loadMembersOfEnterpriseDashboard({
    enterpriseIdOrName,
    params,
    endpoint,
  }: {
    enterpriseIdOrName: string;
    params: object;
    endpoint: string;
  }) {
    const query = _.extend({ fields: Payloads.enterpriseMemberFields }, params);
    return loadApiDataFromPayload('Member', {
      id: enterpriseIdOrName,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/members/${endpoint}`,
      metadataHeaderName: 'X-Trello-API-Query-Meta',
    });
  }

  loadMembersOfEnterprise(enterpriseIdOrName: string, params: object) {
    const query = _.extend({ fields: Payloads.enterpriseMemberFields }, params);
    return loadApiDataFromPayload('Member', {
      id: enterpriseIdOrName,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/members`,
      metadataHeaderName: 'X-Trello-API-Query-Meta',
    });
  }

  loadEnterpriseOrganizations(enterpriseIdOrName: string, params: object) {
    const query = _.extend(
      { fields: Payloads.enterpriseOrganizationFields },
      params,
    );
    return loadApiDataFromPayload('Organization', {
      id: enterpriseIdOrName,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/organizations`,
      metadataHeaderName: 'X-Trello-API-Query-Meta',
    });
  }

  loadEnterprisePendingOrganizations(
    enterpriseIdOrName: string,
    query: object,
  ) {
    return loadApiDataFromPayload('PendingOrganization', {
      id: enterpriseIdOrName,
      payload: {
        query,
        mappingRules: Payloads.pendingOrganizations.mappingRules,
      },
      path: `enterprises/${enterpriseIdOrName}/pendingOrganizations`,
      metadataHeaderName: 'X-Trello-API-Query-Meta',
    });
  }

  loadEnterprisePublicBoards(enterpriseIdOrName: string, params: object) {
    const query = _.extend(params, {
      filter: 'public',
      organization: true,
      members: 'admins',
    });

    return loadApiDataFromPayload('Board', {
      id: enterpriseIdOrName,
      payload: { query },
      path: `enterprises/${enterpriseIdOrName}/boards`,
      metadataHeaderName: 'X-Trello-API-Query-Meta',
    });
  }

  loadEnterpriseStanding(
    modelType: 'Enterprise' | 'Organization',
    orgOrEnterpriseId: string,
  ): BluebirdPromise<Enterprise | Organization> {
    const url = `${Util.pluralize(modelType)}/${orgOrEnterpriseId}/paidAccount`;
    const query = {
      fields: 'enterpriseStanding,pendingDeprovision',
    };
    // This looks like dumb code to branch on because both branches are identical. It's basically so that the TS
    // compiler can infer the correct return type of this function.
    if (modelType === 'Enterprise') {
      return loadApiDataFromPayload(modelType, {
        id: orgOrEnterpriseId,
        payload: { query },
        path: url,
      });
    } else {
      return loadApiDataFromPayload(modelType, {
        id: orgOrEnterpriseId,
        payload: { query },
        path: url,
      });
    }
  }

  loadEnterprise(enterpriseIdOrName: string, query: object) {
    if (query == null) {
      query = {
        organizations: 'all',
        fields: [
          'displayName',
          'idAdmins',
          'idOrganizations',
          'pendingOrganizations',
          'name',
          'organizationPrefs',
          'prefs',
          'products',
          'ssoActivationFailed',
          'ssoDateDelayed',
          'pluginWhitelistingEnabled',
        ].join(','),
      };
    }
    return loadApiDataFromPayload('Enterprise', {
      id: enterpriseIdOrName,
      payload: {
        query,
      },
    });
  }

  loadHighlights({
    before,
    since,
    organization,
  }: {
    before?: string;
    since?: string;
    organization?: string | null;
  }) {
    const query: {
      board_customFields: boolean;
      board_memberships: string;
      card_customFieldItems: boolean;
      action_reactions: boolean;
      before?: string;
      since?: string;
      organization?: string;
    } = {
      board_customFields: true,
      board_memberships: 'all',
      card_customFieldItems: true,
      action_reactions: true,
    };

    if (before) {
      query.before = before;
    }
    if (since) {
      query.since = since;
    }
    if (organization) {
      query.organization = organization;
    }

    return loadApiDataFromPayload('highlights', {
      payload: { query },
      path: 'members/me/highlights',
    });
  }

  loadUpNext() {
    const query = {
      board_customFields: true,
      board_memberships: 'all',
      card_customFieldItems: true,
      action_reactions: true,
    };

    return loadApiDataFromPayload('upNext', {
      payload: { query },
      path: 'members/me/upNext',
    });
  }

  loadMyOrganizations() {
    return this.loadMemberOrganizations('me');
  }

  loadMyOrganizationsWithoutBoards() {
    return this.loadMemberOrganizations(
      'me',
      Payloads.organizationsWithoutBoards,
    );
  }

  loadMyOrganizationsMinimal() {
    return this.loadMemberOrganizations('me', Payloads.organizationsMinimal);
  }

  loadMemberOrganizationsMemberships(idMember: string) {
    return this.loadMemberOrganizations(
      idMember,
      Payloads.organizationsMemberships,
    );
  }

  loadMemberOrganizations(idMember: string, payload?: PayloadQuery | null) {
    if (payload == null) {
      payload = Payloads.organizations;
    }
    return loadApiDataFromPayload('Member', { id: idMember, payload });
  }

  loadSearchData(query: PayloadQuery) {
    return loadApiDataFromPayload('search', {
      payload: { query },
      path: 'search',
    });
  }

  loadModel(modelType: 'Card', id: string, payload: PayloadQuery) {
    return loadApiDataFromPayload(modelType, { id, payload });
  }

  loadBoardPlugins(id: string, locales?: string) {
    // load public plugins, which are cached based on locale
    // then load private ones separately which are not cached
    if (!locales) {
      locales = 'en';
    }
    return BluebirdPromise.all([
      loadApiDataFromPayload('Plugin', {
        payload: {
          query: { preferredLocales: locales },
        },
        path: 'plugins/public',
      }),
      loadApiDataFromPayload('Plugin', {
        payload: {
          query: { filter: 'private' },
        },
        path: `boards/${id}/plugins`,
      }),
    ]).spread((publicPlugins, privatePlugins) => {
      return publicPlugins.concat(privatePlugins);
    });
  }

  loadBoardEnabledPlugins(id: string) {
    return loadApiDataFromPayload('Plugin', {
      payload: {
        query: {
          filter: 'enabled',
        },
      },
      path: `boards/${id}/plugins`,
    });
  }

  loadEnterprisePlugins(id: string) {
    return loadApiDataFromPayload('Plugin', {
      payload: {
        query: { filter: 'all' },
      },
      path: `enterprises/${id}/plugins`,
    });
  }

  loadPluginsWithClaimedDomains(id: string) {
    return loadApiDataFromPayload('Plugin', {
      payload: {
        query: {
          filter: 'hasClaimedDomains',
        },
      },
      path: `boards/${id}/plugins`,
    });
  }

  loadCustomFields(id: string) {
    return loadApiDataFromPayload('Board', {
      id,
      payload: Payloads.customFields,
    });
  }

  loadQuickBoardsData() {
    return loadApiDataFromQuickLoad('MemberQuickBoards', {
      modelType: 'Member',
    });
  }

  loadQuickBoardsSearch(search: string) {
    return loadApiDataFromQuickLoad('QuickBoardsSearch', {
      idModel: search,
      modelType: 'Board',
    });
  }

  loadAction(id: string) {
    return loadApiDataFromPayload('Action', {
      id,
      payload: Payloads.action,
    });
  }

  loadReactions(idAction: string) {
    return loadApiDataFromPayload('Reaction', {
      id: idAction,
      path: `actions/${idAction}/reactions`,
    });
  }
}

// eslint-disable-next-line @trello/no-module-logic
export const ModelLoader = new Loaders();
window.ModelLoader = ModelLoader;
